/* Bucle 2026 — small, dependency-free interactions for the bk- sections. Re-inits on theme editor section loads. */
(function () {
  'use strict';
  var symbol = (window.BucleTheme && window.BucleTheme.currency) || '$';
  function money(cents) {
    var v = cents / 100;
    return symbol + v.toLocaleString('en-US', { minimumFractionDigits: v % 1 ? 2 : 0, maximumFractionDigits: 2 });
  }

  function initTicketForms(root) {
    root.querySelectorAll('[data-bk-tform]').forEach(function (form) {
      if (form.dataset.bkReady) return; form.dataset.bkReady = '1';
      var qty = form.querySelector('[data-bk-qty]');
      var totals = form.querySelectorAll('[data-bk-total]');
      var buyQty = form.querySelectorAll('[data-bk-buyqty]');
      function update() {
        var sel = form.querySelector('input[name="id"]:checked');
        var q = Math.max(1, Math.min(10, parseInt(qty && qty.value, 10) || 1));
        if (qty) qty.value = q;
        var cents = sel ? parseInt(sel.dataset.price, 10) * q : 0;
        totals.forEach(function (t) { t.textContent = money(cents); });
        buyQty.forEach(function (t) { t.textContent = q; });
      }
      form.addEventListener('change', update);
      form.querySelectorAll('[data-bk-step]').forEach(function (b) {
        b.addEventListener('click', function () { if (!qty) return; qty.value = (parseInt(qty.value, 10) || 1) + parseInt(b.dataset.bkStep, 10); update(); });
      });
      if (qty) qty.addEventListener('input', update);
      update();
    });
  }

  function initFilters(root) {
    root.querySelectorAll('[data-bk-filter]').forEach(function (group) {
      if (group.dataset.bkReady) return; group.dataset.bkReady = '1';
      var target = document.getElementById(group.dataset.bkFilter);
      group.addEventListener('click', function (e) {
        var b = e.target.closest('button[data-series]'); if (!b || !target) return;
        group.querySelectorAll('button').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        target.querySelectorAll('[data-series]').forEach(function (card) {
          card.classList.toggle('bk-is-hidden', b.dataset.series !== 'all' && card.dataset.series !== b.dataset.series);
        });
      });
    });
  }

  function initMore(root) {
    root.querySelectorAll('[data-bk-more]').forEach(function (btn) {
      if (btn.dataset.bkReady) return; btn.dataset.bkReady = '1';
      var target = document.getElementById(btn.dataset.bkMore);
      var more = btn.textContent, less = btn.dataset.less || 'Show less';
      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        target.querySelectorAll('[data-extra]').forEach(function (x) { x.classList.toggle('bk-is-hidden', open); });
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        btn.textContent = open ? more : less;
      });
    });
  }

  function initLightbox(root) {
    root.querySelectorAll('[data-bk-gallery]').forEach(function (gal) {
      if (gal.dataset.bkReady) return; gal.dataset.bkReady = '1';
      var lb = document.getElementById(gal.dataset.bkGallery);
      if (!lb) return;
      var img = lb.querySelector('img'), count = lb.querySelector('.c');
      var items = Array.prototype.slice.call(gal.querySelectorAll('[data-full]'));
      var i = 0, last = null;
      function show(n) { i = (n + items.length) % items.length; img.src = items[i].dataset.full; img.alt = items[i].querySelector('img') ? items[i].querySelector('img').alt : ''; count.textContent = (i + 1) + ' / ' + items.length; }
      function close() { lb.hidden = true; document.documentElement.style.overflow = ''; if (last) last.focus(); }
      items.forEach(function (it, n) { it.addEventListener('click', function () { last = it; show(n); lb.hidden = false; document.documentElement.style.overflow = 'hidden'; lb.querySelector('.x').focus(); }); });
      lb.querySelector('.x').addEventListener('click', close);
      lb.querySelector('.p').addEventListener('click', function () { show(i - 1); });
      lb.querySelector('.n').addEventListener('click', function () { show(i + 1); });
      lb.addEventListener('click', function (e) { if (e.target === lb) close(); });
      lb.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); if (e.key === 'ArrowLeft') show(i - 1); if (e.key === 'ArrowRight') show(i + 1); });
    });
  }

  function initYouTube(root) {
    root.querySelectorAll('[data-bk-yt]').forEach(function (b) {
      if (b.dataset.bkReady) return; b.dataset.bkReady = '1';
      b.addEventListener('click', function () {
        var f = document.createElement('iframe');
        f.src = 'https://www.youtube-nocookie.com/embed/' + b.dataset.bkYt + '?autoplay=1&rel=0';
        f.title = b.getAttribute('aria-label') || 'Video';
        f.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; fullscreen';
        f.allowFullscreen = true;
        b.replaceChildren(f); b.removeAttribute('role'); b.style.cursor = 'default';
      }, { once: true });
    });
  }

  function initTimeline(root) {
    root.querySelectorAll('[data-bk-tl]').forEach(function (tl) {
      if (tl.dataset.bkReady) return; tl.dataset.bkReady = '1';
      var tabs = tl.querySelectorAll('[role="tab"]');
      tabs.forEach(function (t) {
        t.addEventListener('click', function () {
          tabs.forEach(function (x) { var on = x === t; x.setAttribute('aria-selected', on ? 'true' : 'false'); x.tabIndex = on ? 0 : -1; document.getElementById(x.getAttribute('aria-controls')).hidden = !on; });
        });
      });
    });
  }

  function initDesktopVideo(root) {
    root.querySelectorAll('video[data-bk-desktop-video]').forEach(function (v) {
      if (v.dataset.bkReady) return; v.dataset.bkReady = '1';
      var big = window.matchMedia('(min-width: 900px)').matches;
      var calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var save = navigator.connection && (navigator.connection.saveData || /2g/.test(navigator.connection.effectiveType || ''));
      if (!big || calm || save) return;
      var start = function () {
        v.src = v.dataset.bkDesktopVideo; v.muted = true;
        v.addEventListener('playing', function () { v.classList.add('is-on'); }, { once: true });
        var p = v.play(); if (p && p.catch) p.catch(function () {});
      };
      if (document.readyState === 'complete') setTimeout(start, 1500); else window.addEventListener('load', function () { setTimeout(start, 1500); }, { once: true });
    });
  }

  function initVideo(root) {
    root.querySelectorAll('video[data-bk-autoplay]').forEach(function (v) {
      v.muted = true; v.defaultMuted = true;
      var p = v.play && v.play(); if (p && p.catch) p.catch(function () {});
    });
  }

  function initCarousels(root) {
    root.querySelectorAll('[data-bk-car]').forEach(function (car) {
      if (car.dataset.bkReady) return; car.dataset.bkReady = '1';
      var track = car.querySelector('.bk-car__track');
      var slides = Array.prototype.slice.call(track.children);
      var dotsWrap = car.querySelector('[data-bk-car-dots]');
      var interval = parseInt(car.dataset.interval, 10) || 5000;
      var calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var cur = -1, timer = null, raf = null, t0 = 0, dur = interval, inView = false, paused = false;
      var dots = slides.map(function (s, i) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'bk-car__dot'; b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        b.appendChild(document.createElement('i'));
        b.addEventListener('click', function () { go(i, true); });
        dotsWrap.appendChild(b); return b;
      });
      function stopTimer() { clearTimeout(timer); cancelAnimationFrame(raf); timer = null; }
      function bar() {
        var d = dots[cur]; if (!d) return;
        var p = Math.min(1, (performance.now() - t0) / dur);
        d.firstChild.style.transform = 'scaleX(' + p + ')';
        if (p < 1) raf = requestAnimationFrame(bar);
      }
      function schedule(ms) {
        stopTimer(); if (calm || paused || !inView) return;
        dur = ms; t0 = performance.now(); bar();
        timer = setTimeout(function () { go((cur + 1) % slides.length); }, ms);
      }
      function activate(i) {
        slides.forEach(function (s, k) {
          s.classList.toggle('is-active', k === i);
          var v = s.querySelector('video');
          if (v && k !== i) { v.pause(); s.classList.remove('is-playing'); }
        });
        dots.forEach(function (d, k) {
          d.classList.toggle('is-active', k === i); d.classList.toggle('is-done', k < i);
          d.firstChild.style.transform = k < i ? 'scaleX(1)' : 'scaleX(0)';
        });
        var v = slides[i].querySelector('video');
        if (v && inView) {
          if (!v.src && v.dataset.src) v.src = v.dataset.src;
          v.muted = true; v.currentTime = 0;
          var p = v.play(); if (p && p.catch) p.catch(function () {});
          slides[i].classList.add('is-playing');
          var go2 = function () {
            var len = isFinite(v.duration) && v.duration > 0 ? Math.min(v.duration, 15) : interval / 1000;
            schedule(len * 1000);
          };
          schedule(15000);
          if (v.readyState >= 1) go2(); else v.addEventListener('loadedmetadata', go2, { once: true });
        } else schedule(interval);
      }
      function go(i, user) {
        if (i === cur) return; cur = i;
        track.scrollTo({ left: slides[i].offsetLeft, behavior: calm ? 'auto' : 'smooth' });
        activate(i);
        if (user) car.dataset.touched = '1';
      }
      car.querySelector('[data-bk-car-prev]').addEventListener('click', function () { go((cur - 1 + slides.length) % slides.length, true); });
      car.querySelector('[data-bk-car-next]').addEventListener('click', function () { go((cur + 1) % slides.length, true); });
      var st;
      track.addEventListener('scroll', function () {
        clearTimeout(st);
        st = setTimeout(function () {
          var i = Math.round(track.scrollLeft / track.clientWidth);
          if (i !== cur && slides[i]) { cur = i; activate(i); }
        }, 120);
      }, { passive: true });
      car.addEventListener('mouseenter', function () { paused = true; stopTimer(); });
      car.addEventListener('mouseleave', function () {
        paused = false; if (cur < 0) return;
        var v = slides[cur].querySelector('video');
        if (v && v.src) { var len = isFinite(v.duration) && v.duration > 0 ? Math.min(v.duration, 15) : 15; schedule(Math.max(1000, (len - v.currentTime) * 1000)); }
        else schedule(interval);
      });
      car.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); go((cur + 1) % slides.length, true); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); go((cur - 1 + slides.length) % slides.length, true); }
      });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) {
          inView = es[0].isIntersecting;
          if (inView) activate(cur < 0 ? (cur = 0) : cur);
          else { stopTimer(); slides.forEach(function (s) { var v = s.querySelector('video'); if (v) v.pause(); }); }
        }, { threshold: 0.35 }).observe(car);
      } else { inView = true; cur = 0; activate(0); }
      if (cur < 0) { cur = 0; slides[0].classList.add('is-active'); dots[0].classList.add('is-active'); }
    });
  }

  function init(root) {
    root = root || document;
    initTicketForms(root); initFilters(root); initMore(root); initLightbox(root); initYouTube(root); initTimeline(root); initVideo(root); initDesktopVideo(root); initCarousels(root);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
